module.exports = __webpack_public_path__ + "media/images/pepsi_home/menu_btn_grey-a902b4d9a8271bfb17d16f598f8f51b7.png";